import axios from "axios";
import Config from "@/config"

export default class StorageService {
    getStorageInfo(accesstoken, userId) {
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} },
            params: {
                "fields":"username",
                "populate[storage][populate][ingredients][populate][ingredient][populate]":"labels,media",
                "populate[storage][populate][storageType][fields]":"id, key",
                "populate[storage][populate][ingredients][populate][unit][populate]":"labels"
            }
        };
        return axios
            .get(
                Config.proxy + Config.url("storage") + "/" + userId,
                options
            )
            .then(res => res.data.storage)
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }

    setStorageInUser(accesstoken, userId, data){
        const options = {
            headers: { ...Config.headers(accesstoken), ...{} },
        }

        return axios
            .put(
                Config.proxy + Config.url("storage") + "/" + userId,
                data,
                options
            )
            .then(res => res.status)
            .catch(
                function (error) {
                console.log('Show error notification!')
                return Promise.reject(error)
                }
            )
    }
    
}
